import { accessToken } from '../modules/auth';

export interface RequestParam {
    url: string;
    method: string;
    params?: Record<string, any>;
    body?: Record<string, any>;
}

export class RequestData {
    private static getUrlEndPointForLantis(endpoint: string, params?: Record<string, any>): string {
        let queryString = '';

        if (params) {
            const queryParams = Object.entries(params).map(([key, value]) => `${key}=${value}`);
            queryString = '?' + queryParams.join('&');
        }

        return `${process.env.REACT_APP_API_BASE_URL || ''}${endpoint}${queryString}`;
    }
    public static async makeRequest({ url, method, params, body }: RequestParam) {
        const token = await accessToken().getAcquireTokenSilent();
        const response = await fetch(this.getUrlEndPointForLantis(url, params), {
            method: method,
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token.accessToken}` },
            body: body ? JSON.stringify(body) : null,
        });
        return response.json();
    }
}
